'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connectWithContext;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function wrapWithContext(mapStateToProps, mapDispatchToProps, contextTypes, component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(ConnectedComponent, _React$Component);

    function ConnectedComponent(props, context) {
      _classCallCheck(this, ConnectedComponent);

      /*
       * This is the magic right here!
       */
      var _this = _possibleConstructorReturn(this, (ConnectedComponent.__proto__ || Object.getPrototypeOf(ConnectedComponent)).call(this, props, context));

      _this.mapStateToProps = mapStateToProps ? function (state, ownProps) {
        return mapStateToProps(state, ownProps, context);
      } : null;
      _this.mapDispatchToProps = mapDispatchToProps ? function (dispatch, ownProps) {
        return mapDispatchToProps(dispatch, ownProps, context);
      } : null;
      _this.component = (0, _reactRedux.connect)(_this.mapStateToProps, _this.mapDispatchToProps)(component);

      // should we do this for other methods too?
      _this.shouldComponentUpdate = _this.component.shouldComponentUpdate;
      return _this;
    }

    _createClass(ConnectedComponent, [{
      key: 'render',
      value: function render() {
        var Component = this.component;
        return _react2.default.createElement(Component, this.props);
      }
    }]);

    return ConnectedComponent;
  }(_react2.default.Component), _class.contextTypes = contextTypes, _temp;
}

var undefinedContextTypesMessage = 'VideoInterface.connectWithContext(fn, fn, contextTypes)\nMethod received a \'null\' value for contextTypes.\nIf context is not needed, use react-redux connect()\n';

/**
 * Enhanced version of react-redux connect that provides context to the map methods.
 *
 * @param {Function} mapStateToProps - The function to mapStateToProps
 * @param {Function} mapDispatchToProps - The function to mapDispatchToProps
*  @param {Object} contextTypes - Must adhere to the contextTypes-style object
 * @returns {Function} - returns a function that wraps a provided component with context
 */
function connectWithContext(mapStateToProps, mapDispatchToProps, contextTypes) {
  (0, _invariant2.default)((typeof contextTypes === 'undefined' ? 'undefined' : _typeof(contextTypes)) === 'object', undefinedContextTypesMessage);

  return function (component) {
    return wrapWithContext(mapStateToProps, mapDispatchToProps, contextTypes, component);
  };
}
module.exports = exports['default'];